import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus-basic",
  "use": "minus-basic-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"minus-basic\"><rect width=\"3\" height=\"16\" x=\"7\" fill-rule=\"evenodd\" rx=\"1.5\" transform=\"rotate(-90 8.5 8)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol